import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=c3cf7b96&scoped=true"
import script from "./NavButton.vue?vue&type=script&lang=js"
export * from "./NavButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cf7b96",
  null
  
)

export default component.exports